window.addEventListener('load', function() {
  $('a[href^="#"].smooth').on('click', function() {
    var adjust = 0;
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
});

$(window).on('scroll', function() {
  var headerBottom = $('#site-header').offset().top + $('#site-header').outerHeight();

  if ($(this).scrollTop() > headerBottom) {
    $('.mobile-menu-button').css('display', 'block');
  } else {
    $('.mobile-menu-button').css('display', 'none');
  }
});


window.addEventListener('load', function() {

  $(document).ajaxStop(function() {

    // 閲覧履歴の商品取得を画面近くまで遅延するため、空の状態や
    // 既に初期化済みのスライダーを Slick 化しない。
    let slider = $('.aw-recently-viewed__list').filter(function() {
      return $(this).children().length && !$(this).hasClass('slick-initialized');
    });
    if (slider.length) {


      slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        speed: 500,
        arrows: true,
        lazyLoad: "progressive",
        dots: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            // centerMode: true,
            // centerPadding: '30px',
            dots: false,
          }
        }]
      });

      let counter = $('.aw-recently-viewed__counter');
      let currentSlideEle = $('.aw-recently-viewed__counter-current');
      let totalSlidesEle = $('.aw-recently-viewed__counter-all');

      $('.aw-recently-viewed .slick-arrow').each(function() {
        let clonedElement = $(this).clone(true);
        counter.append(clonedElement);
      });

      totalSlidesEle.text(slider.slick('getSlick').slideCount);

      slider.on('afterChange', function(event, slick, currentSlide) {
        let currentSlideNumber = currentSlide + 1;
        let formattedSlideNumber = (currentSlideNumber);

        currentSlideEle.text(formattedSlideNumber);
      });


      $(window).on("resize orientationchange", function() {
        $(".aw-recently-viewed__list").slick("resize");
      });

    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const noteInput = document.querySelector('textarea[name="note"]');
  if (!noteInput) return;

  // ページ読み込み時に現在の note を取得して同期
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      if (data.note) {
        noteInput.value = data.note;
      }
    });

  // 入力したら即保存（負荷を減らすなら debounce 推奨）
  noteInput.addEventListener("input", function() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: noteInput.value })
    }).catch(console.error);
  });
});
